exports = module.exports = require("./../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".date-picker-active-label{font-size:.8rem!important;-webkit-transform:translateY(-140%);transform:translateY(-140%)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/vue-loader/lib/style-rewriter.js!../~/vue-loader/lib/selector.js?type=style&index=0!../~/material-ui-vue/components/forms/date-picker.vue
 ** module id = 302
 ** module chunks = 0
 **/